function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { extend, nodeOrNew, register, wrapWithAttrCheck } from '../utils/adopter.js';
import { globals } from '../utils/window.js';
import { registerMethods } from '../utils/methods.js';
import SVGNumber from '../types/SVGNumber.js';
import Shape from './Shape.js';
import Text from './Text.js';
import * as textable from '../modules/core/textable.js';
var Tspan = /*#__PURE__*/ function(Shape) {
    "use strict";
    _inherits(Tspan, Shape);
    function Tspan(node) {
        var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : node;
        _class_call_check(this, Tspan);
        var _this;
        _this = _call_super(this, Tspan, [
            nodeOrNew('tspan', node),
            attrs
        ]);
        _this._build = false // disable build mode for adding multiple lines
        ;
        return _this;
    }
    _create_class(Tspan, [
        {
            // Shortcut dx
            key: "dx",
            value: function dx(dx) {
                return this.attr('dx', dx);
            }
        },
        {
            // Shortcut dy
            key: "dy",
            value: function dy(dy) {
                return this.attr('dy', dy);
            }
        },
        {
            // Create new line
            key: "newLine",
            value: function newLine() {
                // mark new line
                this.dom.newLined = true;
                // fetch parent
                var text = this.parent();
                // early return in case we are not in a text element
                if (!_instanceof(text, Text)) {
                    return this;
                }
                var i = text.index(this);
                var fontSize = globals.window.getComputedStyle(this.node).getPropertyValue('font-size');
                var dy = text.dom.leading * new SVGNumber(fontSize);
                // apply new position
                return this.dy(i ? dy : 0).attr('x', text.x());
            }
        },
        {
            // Set text content
            key: "text",
            value: function text(text) {
                if (text == null) return this.node.textContent + (this.dom.newLined ? '\n' : '');
                if (typeof text === 'function') {
                    this.clear().build(true);
                    text.call(this, this);
                    this.build(false);
                } else {
                    this.plain(text);
                }
                return this;
            }
        }
    ]);
    return Tspan;
}(Shape);
export { Tspan as default };
extend(Tspan, textable);
registerMethods({
    Tspan: {
        tspan: wrapWithAttrCheck(function() {
            var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            var tspan = new Tspan();
            // clear if build mode is disabled
            if (!this._build) {
                this.clear();
            }
            // add new tspan
            return this.put(tspan).text(text);
        })
    },
    Text: {
        newLine: function newLine() {
            var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            return this.tspan(text).newLine();
        }
    }
});
register(Tspan, 'Tspan');
